import { Image, Typography } from '@components'

import { Constant, theme } from '@utils'

import SvgImage from '@components/svg'
import {
  StyleTableUserLabel,
  StyleUserInfoRow,
  StyleUserInfoWrapper,
} from './style'

const TableUser = ({
  avatar,
  label,
  secondaryLabel,
  isVerified = false,
  hasAvatar,
  bookCover,
}: {
  avatar?: string
  label: string
  secondaryLabel?: string
  isVerified?: boolean
  hasAvatar?: boolean
  bookCover?: boolean
}) => {
  return (
    <StyleUserInfoRow>
      {hasAvatar && (
        <Image
          width={30}
          height={30}
          src={
            !!avatar
              ? `${process.env.BUCKET_URL}/${avatar}`
              : Constant?.defaultUser
          }
          customStyle={{ borderRadius: '50%' }}
        />
      )}
      {bookCover && (
        <Image
          width={50}
          height={60}
          src={
            !!avatar
              ? `${process.env.BUCKET_URL}/${avatar}`
              : Constant?.defaultUser
          }
          customStyle={{ borderRadius: 8 }}
        />
      )}

      <StyleUserInfoWrapper>
        <StyleUserInfoRow>
          <StyleTableUserLabel customStyle={{ width: 'max-content' }}>
            {label}
          </StyleTableUserLabel>
          {isVerified && (
            <SvgImage
              src={'isApproved'}
              color={theme.colors.primary}
              height={16}
              width={16}
            />
          )}
        </StyleUserInfoRow>

        {!!secondaryLabel && (
          <Typography tc="grey300" weigth={400}>
            {secondaryLabel}
          </Typography>
        )}
      </StyleUserInfoWrapper>
    </StyleUserInfoRow>
  )
}

export default TableUser
